import axios from '../axios';

const rolesApi = {
  getAll: (companyId) => axios.get(`/Roles?companyId=${companyId}`),
  getById: (id) => axios.get(`/Roles/${id}`),
  create: (data) => axios.post('/Roles', data),
  update: (id, data) => axios.put(`/Roles/${id}`, data),
  delete: (id) => axios.delete(`/Roles/${id}`),
  syncPermissions: () => axios.post('/Roles/sync-permissions'),
  
  getPermissions: () => axios.get('/Permissions'),
};

export default rolesApi;
